import translate from "../../../common/Dictionary";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight, faSearch } from '@fortawesome/free-solid-svg-icons';
import checkFill from "../../../../img/icon_fill_check.svg";
import warningFill from "../../../../img/icon_fill_warning.svg";
import errorFill from "../../../../img/icon_fill_error.svg";

const StepTwo = ({ state, userData, setState, getPostCode, getProvider, onNext, onBack }) => {
    return (
        <div className="axa-project-card">
            <div className="axa-subcat-card-padding axa-card-shadow mt-4 bg-white" >
                <div className="axa-mobile-hidden" style={{ "height": "32px" }}></div>
                <div className="axa-service-card-title align-left pt-5">{translate("newProjectTitleExpert", userData.language)}</div>
                <div className="title-sub-text align-left pt-4 pb-4">{translate("newProjectTextExpert", userData.language)}</div>
                <hr className="axa-service-card-diveder" />
                <div style={{ display: state.checkProviderResult === "no-result" ? "" : "none" }}>
                    <div className="text-start " style={{ display: (state.showPostCodeError ? "" : "none") }}>
                        <div className="axa-error-box mt-5">
                            <div className="p-3" align="left">
                                <div className="d-flex gap-3">
                                    <div>
                                        <img src={errorFill} alt="check-provider" />
                                    </div>
                                    <div className="flex-fill">
                                        <div className="axa-success-box-header pt-1">
                                            {translate("newProjectExpertCheckPostCodeErrorHeader", userData.language)}
                                        </div>
                                        <div className="axa-success-box-text py-2">
                                            {translate("newProjectExpertCheckPostCodeErrorText", userData.language)}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    
                    <div className="row">
                        <div className="col-md-3 col-sm-12 mb-1">
                            <div className="title-sub-text align-left pt-4 mb-1 d-flex">
                                <label htmlFor="textbox-postal-code">{translate("newProjectLabelExpertPostCode", userData.language)}</label>
                            </div>
                            <div className="input-group">
                                <input
                                    id="textbox-postal-code"
                                    type="text"
                                    className="form-control"
                                    onChange={(event) => setState({ ...state, checkPostalCode: event.target.value })}
                                    value={state.checkPostalCode}
                                />
                                <button
                                    className="btn btn-outline-primary btn-sm"
                                    type="button"
                                    onClick={getPostCode}
                                >
                                    <FontAwesomeIcon icon={faSearch} />
                                </button>
                            </div>
                        </div>
                        <div className="col-md-5 col-sm-12" style={{ display: (state.availablePostalAreas.length === 0 ? "none" : "") }}>
                            <div className="title-sub-text align-left pt-4 mb-1 d-flex">
                                <label htmlFor="select-provider-city">{translate("newProjectCustomerInfoLabelCity", userData.language)}</label>
                            </div>
                            <select
                                id="select-provider-city"
                                value={state.selectedPostalAreaId}
                                className="form-select text-primary"
                                onChange={(event) => setState({ ...state, selectedPostalAreaId: event.target.value })}
                            >
                                {state.availablePostalAreas.map((area, index) => {
                                    return <option key={"postalAreaOption-"+index} value={area.id}>{area.cityPostalArea}</option>
                                }) }
                            </select>
                        </div>
                    </div>
                    <div className="axa-under-text align-left">{translate("newProjectLabelExpertUnderText", userData.language)}</div>
                    <div className="row" style={{ display: (state.availablePostalAreas.length === 0 ? "none" : "") }}>
                        <div className="col-md-6 col-sm-12 mt-4 d-grid" align="left">
                            <button
                                className="btn btn-primary"
                                onClick={getProvider}
                            >
                                {translate("newProjectExpertCheckAvailabilityButton", userData.language)}
                            </button>
                        </div>
                    </div>
                </div>
                <div style={{ display: state.checkProviderResult === "found" ? "" : "none" }}>
                    <div className="axa-success-box mt-5">
                        <div className="p-3" align="left">
                            <div className="d-flex gap-3">
                                <div>
                                    <img src={checkFill} alt="check-provider" />
                                </div>
                                <div className="flex-fill">
                                    <div className="axa-success-box-header pt-1">
                                        {translate("newProjectExpertCheckSuccessTitle", userData.language)}
                                    </div>
                                    <div className="axa-success-box-text py-2">
                                        {translate("newProjectExpertCheckSuccessText", userData.language)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ display: state.checkProviderResult === "not-found" ? "" : "none" }}>
                    <div className="axa-warning-box mt-5">
                        <div className="p-3" align="left">
                            <div className="d-flex gap-3">
                                <div>
                                    <img src={warningFill} alt="warning-provider" />
                                </div>
                                <div className="flex-fill">
                                    <div className="axa-success-box-header pt-1">
                                        {translate("newProjectExpertCheckWarningTitle", userData.language)}
                                    </div>
                                    <div className="axa-success-box-text py-2">
                                        {translate("newProjectExpertCheckWarningText", userData.language)}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="row justify-content-end pt-5" style={{ display: state.checkProviderResult === "not-found" ? "" : "none" }}>
                <div className="col axa-header-SansPro-24-700">
                    {translate("newProjectDoYouWantToContinue", userData.language)}
                </div>
            </div>
            <div className={"d-flex flex-column-reverse flex-md-row pt-4 " + (state.checkProviderResult === "not-found" ? "justify-content-end" : "justify-content-between")}>
                <button
                    className={"btn " + (state.checkProviderResult === "not-found" ? "btn-outline-primary me-4" : "text-secondary")}
                    onClick={onBack}
                >
                    <FontAwesomeIcon className="me-1" icon={faArrowLeft} />
                    {state.checkProviderResult === "not-found" ? translate("btnNoExpertBack", userData.language) : translate("newProjectBack", userData.language)}
                </button>
                <button
                    className="btn btn-secondary"
                    disabled={state.checkProviderResult === "no-result"}
                    onClick={onNext}
                >
                    {state.checkProviderResult === "not-found" ? translate("btnNoExpertProjectForward", userData.language) : translate("btnProjectForward", userData.language)}
                    <FontAwesomeIcon className="ms-1" icon={faArrowRight} />
                </button>
            </div>
        </div>
    );
};

export default StepTwo;
